import React from 'react';

import { Navigate } from 'react-router';
import {
    BlankLayout,
    NotFound,
    Forbidden,
    Unauthorized,
    NoPrescriber,
} from '@europrocurement/flexy-components';
import { KeycloakRoute, REALM_DEBUG } from '@europrocurement/l2d-keycloak';
import { Debug, ParcoursFormaliteRouter, SocietesRouter } from '@europrocurement/l2d-modules';
import { getCustomiserState } from '@europrocurement/l2d-domain';
import { grilleTarifaireRouter } from '@europrocurement/l2d-modules/src/modules/GrilleTarifaire/grilleTarifaireRouter';
import FooterAssistanceConnected from './FooterAssistanceConnected';
import { FactureRouter } from '../pages/Factures';

import { version } from '../../package.json';
import { DossierRouter } from '../pages/Dossiers';
import Accueil from '../pages/Accueil/Accueil';
import { OrderRouter } from '../pages/Orders';
import menuEntries from './menuEntries';
import L2DFlayout from './L2DFLayout';

const Router = [
    {
        path: '/',
        element: (
            <L2DFlayout
                menuEntries={menuEntries}
                footerProps={{
                    children: <FooterAssistanceConnected />,
                }}
            />
        ),
        children: [
            { path: '/', element: <Navigate to="/accueil" /> },
            {
                path: 'accueil',
                exact: true,
                element: <Accueil />,
            },
            {
                path: 'debug',
                element:
                    getCustomiserState().env === 'prod' ? (
                        <KeycloakRoute roles={REALM_DEBUG}>
                            <Debug panelEnvironnement={{ version }} />
                        </KeycloakRoute>
                    ) : (
                        <Debug panelEnvironnement={{ version }} />
                    ),
            },
            ParcoursFormaliteRouter,
            DossierRouter,
            OrderRouter,
            SocietesRouter,
            grilleTarifaireRouter,
            FactureRouter,
        ],
    },
    {
        path: '/errors',
        element: <BlankLayout />,
        children: [
            { path: '404', element: <NotFound /> },
            { path: '403', element: <Forbidden /> },
            { path: '401', element: <Unauthorized /> },
            {
                path: 'noPrescriber',
                element: <NoPrescriber />,
            },
        ],
    },
    {
        path: '*',
        element: <NotFound />,
    },
];

export default Router;
